import { Switch } from "../ui/switch"

export function ValueRecoveryControl({
  id,
  title,
  description,
  marketplaceName,
  enabled,
  disabled,
  isChecking,
  onChange,
}: {
  id: string
  title: string
  description: string
  marketplaceName: string
  enabled: boolean
  disabled: boolean
  isChecking: boolean
  onChange: (enabled: boolean) => void
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
      <div className="max-w-prose">
        <label htmlFor={id} className="text-sm font-medium">
          {title}
        </label>

        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        <span className="text-sm text-muted-foreground">{`${isChecking ? "Last read" : "Saved"} ${enabled ? "ON" : "OFF"}`}</span>

        <Switch
          id={id}
          label={`${title} for ${marketplaceName}`}
          checked={enabled}
          disabled={disabled}
          onCheckedChange={onChange}
        />
      </div>
    </div>
  )
}
